import type { LayoutData } from "@ServerTypes/layoutView/layoutView.schema";

/**
 * The three kinds of sidebar layout.
 *
 * - `system`   — shipped by CUBE (All Modules, CDE, Project Management, Digital Twin). Immutable for
 *                everyone, Super Admin included.
 * - `personal` — created by, and visible only to, its owner.
 * - `shared`   — published to the whole portal; governed by the three shared-layout permissions.
 *
 * Derived rather than stored: the backend has no `kind` field, and `createView` forces
 * `isDefault: false` while the route schema strips `code`, so a duplicate of a system layout is
 * automatically `personal` with no client-side bookkeeping.
 *
 * `isDefault` is the same flag `components/Views` keys its "Default" tag off, so the two agree.
 * There is no "someone else's personal layout" case: getViewData only returns non-shared rows whose
 * `createdBy` is the caller or the system user, so every `personal` row here is already the
 * caller's own — which is why this takes no current-user argument.
 */
export type LayoutKind = "system" | "personal" | "shared";

export function layoutKind(layout: LayoutData): LayoutKind {
  if (layout.isDefault === true) return "system";
  return layout.isShared === true ? "shared" : "personal";
}
